import React from "react";
import { NavLink } from "react-router-dom";
import { X } from "lucide-react";
import singlePlan from "../../assets/images/svgs/other/singlePlan.svg";
import subscPlan from "../../assets/images/svgs/other/subscriptionPlan.svg";

const Plan = ({ open, onClose, from, state }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Overlay */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
      />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Select Plan Type
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>
        <div className="border-b mb-4" />

        {/* Options */}
        <div className="grid grid-cols-2 gap-4">
          <NavLink
            to="/add-new-order"
            state={{ orderType: "single", from, customerId: state?.customerId }}
            onClick={() => {
              // console.log("Customer ID:", state?.customerId); // ✅ HERE
              onClose();
              localStorage.removeItem("subscribe_tab");
            }}
            className="border rounded-xl p-5 flex flex-col justify-center items-center bg-[#FAFAFA] hover:border-orange-500 hover:bg-orange-50 transition text-center"
          >
            <span className="mb-2 ">
              <img
                src={singlePlan}
                alt="singleplan"
                className="w-auto h-auto"
              />
            </span>

            <h3 className="font-medium text-gray-800">Single Order</h3>
          </NavLink>

          <NavLink
            to="/add-new-order"
            state={{
              orderType: "subscription",
              from,
              customerId: state?.customerId,
            }}
            onClick={() => {
              // console.log("Customer ID:", state?.customerId); // ✅ HERE
              onClose();
            }}
            className="border rounded-xl p-5 bg-[#FAFAFA] flex flex-col justify-center items-center hover:border-orange-500 hover:bg-orange-50 transition text-center"
          >
            <span  >
              <img src={subscPlan} alt="singleplan" className="w-auto h-auto" />
            </span>
            <h3 className="font-medium text-gray-800">Subscription</h3>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Plan;
